export const classNamesTimeline: { [property: string]: string } = {
  StyleEditIconButton: 'StyleEditIconButton',
  StyleFloatingActionRoot: 'StyleFloatingActionRoot',
  StyleFloatingTruckIconRoot: 'StyleFloatingTruckIconRoot',
  StyledHOSEventViewSection: 'StyledHOSEventViewSection',
  StyledFloatingReSequenceStopIconRoot: 'StyledFloatingReSequenceStopIconRoot',
};
